

  <div class="modal-body m-3 ">
      <div class="m-3 p-3" [innerHTML]="termsText | markdown"></div>

      <div class="text-center">
        <button type="button" class="btn btn-primary " data-dismiss="modal" (click)="close()" > {{ "close" | translate }} </button>
      </div>
  </div>
